export default function Contact() {
  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <h1 className="text-3xl font-bold mb-4 text-gray-900">Contact Us</h1>
      <p className="text-lg text-gray-700 mb-2">
        Have a question, suggestion, or want to bring HollerFinds to your town?
      </p>
      <p className="text-lg text-gray-700">
        Email us at <a href="mailto:hello@hollerfinds.com" className="text-orange-600 underline hover:text-orange-800">hello@hollerfinds.com</a> and we'll get back to you soon!
      </p>
    </main>
  );
} 